import React from "react";
import Icon from "../../icons/Icon";
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";




const AppIcon = ({imageUrl, appName, isDefault} : {imageUrl?: string, className?: string, appName?: string, isDefault?: boolean}) => {   

    if (!imageUrl || isDefault){
        return <Icon className={"app-image default-app-icon"} iconName={IconLibrary.THRIVE} sizeInPx="14" color={"var(--thriveGreyDark)"}/>
    }
    
    return (
        <img data-tooltip-id="app-image-tooltip" src={imageUrl} className={`app-image`} alt={appName ?? "App Icon"}/>
    );
}

export default AppIcon